<template>
  <div>
    <div class="loading" v-if="display.loading">
      <div class="load">
        <hr><hr><hr><hr>
        <div class="loadback"></div>
      </div>
    </div>
    <div v-if="display.loaded">
      <section class="project-detail-sec-main project-more-sec" v-if="project.description && project.description !== 'null'">
        <div class="container">
          <div class="custImageGallery">
            <div class="imgBox">
              <img :src="getProjImage(project.image_rectangle)" @click.self="selectDetailed(getProjImage(project.image_rectangle))" alt="alt">
            </div>
            <div class="imgBox videoBox" v-if='project && project.story && isrestrictState!=true && project.story.story_medias != null && project.story.story_medias !=""' v-for="(story_media, index) in project.story.story_medias" :key="index">
              <div v-if="story_media.type === 'photo'">
                <img :src="story_media.url" alt="alt" :id="'project_extra_image_' + index" @click.self="selectDetailed(story_media.url)"  @error="onImageLoadFailure($event, 'project_extra_image_' + index)">
              </div>
              <div v-if="story_media.type === 'video_url'">
                <!-- <iframe :src="getYoutubeThumbnail(story_media.url)"></iframe> -->
                <img :src="getYoutubeThumbnail(story_media.url)" alt="alt"  @click="openYoutubeVideo(story_media.url)" v-if="story_media.type === 'video_url'">
                <div v-if="story_media.type === 'video_url'" class="play_icon">
                  <img src="/static/uploads/youtube-play-icon.png" @click="openYoutubeVideo(story_media.url)" alt="alt">
                </div>
              </div>
            </div>
          </div>
          <div class="project-detail-white-box white-card">
            <div class="row">
              <!-- <div class="col-md-5">
                <img class="img-responsive img-rounded" :src="getProjImage(project.image_rectangle)" @click.self="selectDetailed(getProjImage(project.image_rectangle))" alt="alt">
                <div class="img-row" style="margin-top:20px;" v-if='project && project.story && isrestrictState!=true && project.story.story_medias != null && project.story.story_medias !=""'>
                  <div class="media" v-for="(story_media, index) in project.story.story_medias" :key="index">

                    <img :src="getYoutubeThumbnail(story_media.url)" alt="alt"  @click="openYoutubeVideo(story_media.url)" v-if="story_media.type === 'video_url'">
                    <div v-if="story_media.type === 'video_url'" class="play_icon">
                      <img src="/static/uploads/youtube-play-icon.png" @click="openYoutubeVideo(story_media.url)" alt="alt">
                    </div>

                    <img :src="story_media.url" alt="alt"
                        :id="'project_extra_image_' + index"
                        v-if="story_media.type === 'photo'"
                        @click.self="selectDetailed(story_media.url)"
                        @error="onImageLoadFailure($event, 'project_extra_image_' + index)">
                  </div>
                </div>
              </div> -->
              <div class="col-md-5">
                <div class="projectDetailsLeftSec">
                  <h2>{{project.project_title}}  <!-- <span style ="margin-right: 0px !important;top: initial !important;" v-if="user && globalProjectresp.indexOf(project.id) === -1" @click="fav(project)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"><i class="fas fa-heart"></i></span> --></h2>
                  <div class="custCategoryList">
                    <div class="tags">
                      <div class="icon">
                        <img :src="'/static/front/images/category-list-new.svg'" alt="alt" style="width:17px">
                      </div>
                      <div class="tag-text">
                        <span>
                          {{getProjCategory(project.categories)}}
                        </span>
                      </div>
                    </div>
                    <div class="tags">
                      <div class="icon">
                        <img :src="'/static/front/images/location-pin.svg'" alt="alt" style="width:17px">
                      </div>
                      <div class="tag-text">
                        <span>
                          {{getProjCountry(project.country)}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <p class="sdg-sec">
                    <span v-for="goal in project.goals" :key="goal.id" id="invite-css-tooltip" data-container="body" data-toggle="popover" v-tooltip.bottom="{ html: 'csv-tooltip' + goal.id, class: 'tooltip-custom tooltip-other-custom sdg-tooltip' }">
                      <img :src="'/static/front/images/goal_icons/Cropped' + goal.id + '.png'" alt="alt">
                      <div :id="'csv-tooltip'+goal.id">
                        <b> Goal {{goal.id}} : {{goal.name}} </b> <br>
                        <img style="width: 25px; height: 25px;" :src="'/static/front/images/goal_icons/Cropped' + goal.id + '.png'" alt="alt">
                        <br>
                        <a class="white-btn" href="https://b1g1.com/sustainable-development-goals/" target="_blank">Learn More</a>
                      </div>
                    </span>
                  </p>
                  <div class="custProjectBySec">
                    <span style ="display: inline-block; top: initial !important; position: inherit;" v-if="user && globalProjectresp.indexOf(project.id) === -1" @click="fav(project, 0)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"
                    v-tooltip.top="{ content: 'Click on the heart to favourite', class: 'normal-tooltip' }"
                    class="infopop" data-container="body" data-toggle="popover"><i class="fas fa-heart"></i></span>
                    <p v-if="user && isrestrictState!=true">
                      Project managed by:
                      <strong v-if="showProfilePage == 1 && project.user_id !== variousWcId"><a  class="link-projectdetail-by" target="_blank" :href="getPartnerUrl(project.user_id)">{{getPartnerName(project.user_id)}}</a></strong>
                      <strong v-else>{{getPartnerName(project.user_id)}}</strong>
                    </p>
                    <p v-else-if="user">
                      <span style ="display: inline-block; top: initial !important; position: inherit;" v-if="user && globalProjectresp.indexOf(project.id) === -1" @click="fav(project, 0)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"
                      v-tooltip.top="{ content: 'Click on the heart to favourite', class: 'normal-tooltip' }"
                      class="infopop" data-container="body" data-toggle="popover"><i class="fas fa-heart"></i></span>
                    </p>
                  </div>
                  <div class="custAddImpactLevelSec">
                    <div class="impactLevelTitle">
                      Impact Level <span
                      v-tooltip.top="{ content: 'Select the level of impacts you want to create with this project.', class: 'normal-tooltip' }"
                      class="infopop" data-container="body" data-toggle="popover" style="vertical-align: top;line-height: normal;font-size: 0;padding-top: 0px;display: inline-block;"><img src="/static/front/images/info-icon.svg" alt=""></span>
                      <!-- <a href="#" data-beacon-article="620f404ed86136157d9a5cdc" style="font-size: 0;">
                        <img src="/static/front/images/question-icon.svg" alt="alt">
                      </a> -->
                    </div>
                    <select v-model='selectedImpactLevel' class="ufxd-combobox" id="impactlevel" v-if="detailedProject">
                      <option v-for="item in detailedProject.impacts" :value="item" :key="item.id">
                        <!-- US ${{item.impact_level_cost}} - {{item.impact_level_title}} -->
                        US ${{ user ? item.impact_level_cost : '****' }} - {{ item.impact_level_title }}
                      </option>
                    </select>
                    <div class="custAddtoCartBox" v-if="user">
                      <div class="qty-sec">
                        <input type="button" value="-" @click="decrease(project)">
                        <input type="text" :id="'qty' + project.id" :value="1">
                        <input type="button" value="+" @click="increase(project)">
                      </div>
                      <p :class="project.should_exclude != '1' ? 'btn-sec rml-10' : 'btn-sec'" style="display: inline-block;">
                        <button class="red-btn" @click="addToCart(project, selectedImpactLevel)" :disabled="(user && user.role_id === 12)?true:false">
                          <img src="/static/front/images/shopping_cart_icon.svg" alt="alt">
                          Add to cart
                        </button>
                      </p>
                    </div>
                    <div :class="project.should_exclude != '1' ? 'pro-btn' : 'pro-btn rmt-30'"  v-if="user">
                      <div class="add-to-f-btn" id="add-to-btn" v-if="project.should_exclude != '1'">
                        <a class="b-btn white-btn" href="javascript:void(0)" @click="loadProjectModal(project, 'manual')" id="create_giving__btn" data-backdrop="static" data-keyboard="false" :disabled="display.saiving ? true : false" >Create Recurring Impacts</a>
                      </div>
                    </div>
                    <div class="pro-btn" style="margin-top:1rem;" v-else>
                      <router-link class="b-btn red-btn" :to="{ name: 'login'}">Login To Give</router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-7">
                <div class="project-detail-sec">
                  <h2>Project Description</h2>
                  <p v-html="project.description"></p><br />
                  <h2 v-if="story_text && story_text !== 'null'">More About This Project</h2>
                  <p class="ng-binding" v-html="story_text" v-if="story_text && story_text !== 'null'"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="project-timeline-sec" v-if="approvedUpdates && approvedUpdates.length > 0 && user && isrestrictState!=true">
        <div class="container">
          <div class="time-sec">
            <div class="row">
              <div class="col-md-12">
                <div class="timeTop">
                  <h2>Updates from the Worthy Cause</h2>
                  <aside>
                    <div class="top-arrow" v-if="arrowFlag!=0" @click='moveProjectUpdate("up")'>
                      <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1.57788L1.70711 6.87077C1.31658 7.2613 1.31658 7.89446 1.70711 8.28499L7 13.5779" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <ul class="fade-select for-dektop" id='project_date'>
                      <li style="padding:10px !important;"></li>
                      <li style="padding:10px !important;"></li>
                      <li v-for="(projectUpdate, index) in approvedUpdates" :key="projectUpdate.id" @click="changeDate(index,projectUpdate)" :class = "selectedDate==projectUpdate ? 'active' : ''" style="cursor:pointer;">{{projectUpdate.date}} </li>
                      <li style="padding:10px !important;"></li>
                      <li style="padding:10px !important;"></li>
                    </ul>
                    <div class="bottom-arrow" v-if="arrowFlag!=approvedUpdates.length-1" @click='moveProjectUpdate("down")'>
                      <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1.57788L6.29289 6.87077C6.68342 7.2613 6.68342 7.89446 6.29289 8.28499L1 13.5779" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </div>
                    <ul class="fade-select for-mobile">
                      <li v-for="(projectUpdate, index) in approvedUpdates" :key="projectUpdate.id" @click="changeDate(index,projectUpdate)" :class = "selectedDate==projectUpdate ? 'active' : ''" style="cursor:pointer;"> {{projectUpdate.date}} </li>
                    </ul>
                  </aside>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <div id="carouselExampleControls" class="carousel slide project-img-slide" data-ride="carousel" v-if="projectUpdate.sliderimages.length > 1">
                  <div class="carousel-inner">
                    <div class="carousel-item" v-for="(sliderItem, index) in projectUpdate.sliderimages" :key="index" :class="(index === 0) ? 'active' : ''">
                      <section v-if="sliderItem.type === 'image'">
                        <img class="update-image" :id="'updateImage' + index" :src="sliderItem.link" @error="onImageLoadFailure($event, 'updateImage' + index)" alt="alt">
                      </section>
                      <section v-else>
                        <iframe :src="sliderItem.link" allowfullscreen frameborder="0" class="projectSliderVideoItem"></iframe>
                      </section>
                    </div>
                  </div>
                  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                    <i class="fas fa-chevron-left"></i>
                  </a>
                  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                    <i class="fas fa-chevron-right"></i>
                  </a>
                </div>
                <aside v-if="projectUpdate.sliderimages.length == 1">
                  <img class="projectSliderImageItem" :src="projectUpdate.sliderimages[0].link" v-if="projectUpdate.sliderimages[0].type === 'image'" alt="alt" id="wc_project" @error="onImageLoadFailureWC($event, 'wc_project')">
                  <iframe :src="projectUpdate.sliderimages[0].link" allowfullscreen frameborder="0" class="projectSliderVideoItem" v-if="projectUpdate.sliderimages[0].type === 'video'"></iframe>
                </aside>
              </div>
              <div class="col-md-7">
                <div class="timeContent">
                <!-- <span v-if="projectUpdate.image">
                  <img :src="projectUpdate.image" alt="alt">
                </span >
                  <span v-else-if='projectUpdate.video != null'>
                  <iframe style="vertical-align: middle;" :src="projectUpdate.video" allowfullscreen frameborder="0"></iframe>
                </span> -->
                  <h3>{{projectUpdate.project_title}} <span class="updateDate">{{projectUpdate.date}}</span></h3>
                  <p v-html="getUpdatedText(projectUpdate.project_text)"></p>
      <!--            <p v-else>{{ projectUpdate.project_text ? projectUpdate.project_text.substring(0,1000)+".." : '' }}</p>-->
    <!--                  <a class="b-btn blue-btn" href="#" v-if="projectUpdate.project_text && projectUpdate.project_text.length>1000">read more</a>-->
    <!--              <P class="read-btn"><router-link class="b-btn blue-btn" target="_blank" :to="{ name: 'project-updates.list' }" v-if="user">read more</router-link></P>-->
                  <p class="read-btn"><router-link class="b-btn blue-btn" target="_blank" :to="{ name: 'project-updates.details', params: {id: projectUpdate.id } }">read more</router-link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="project-more-sec owl-for-desktop" v-if="similarProjects.length">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h2 style="text-align: center;">Other Similar Projects</h2>
            </div>
          </div>
          <div class="row justify-content-center" style="margin-top:15px;">
            <div class="col-lg-3 col-md-6" v-for="project in similarProjects" v-bind:key="project.id">
              <div class="project-card">
                <div class="cardSmallLinks">
                  <span v-if="user && globalProjectresp.indexOf(project.id) === -1" @click="fav(project, 0)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"
                  v-tooltip.top="{ content: 'Click on the heart to favourite', class: 'normal-tooltip' }"
                  class="infopop" data-container="body" data-toggle="popover"><i class="fas fa-heart"></i></span>
                  <router-link class="custViewDetailLink" :to="{ name: project.is_bundle == 0 ? 'projectdetail' : 'bundledetail', params: {id: project.id } }" id="project-details-detail"><span
                    v-tooltip.top="{ content: 'Click on the i or the project image to learn more about the project', class: 'normal-tooltip' }"
                    class="infopop" data-container="body" data-toggle="popover"><img :src="'/static/front/images/info-icon-black.svg'" alt="alt"></span></router-link>
                </div>
                <img v-if="project && project.image_rectangle" :src="getProjectImage(project.image_rectangle.image_name)" :id="'project_image_' + project.id" @error="onImageLoadFailure($event, 'project_image_' + project.id)" @click="redirectAnotherProject(project)" style="cursor: pointer" alt="alt">
                <div class="card-text">
                  <h2>
                    <router-link class="" :to="{ name: project.is_bundle == 0 ? 'projectdetail' : 'bundledetail', params: {id: project.id } }" id="project-details-detail">
                      {{project.project_title}}
                    </router-link>
                  </h2>
                  <div class="cardCatMain">
                    <aside>
                      <img :src="'/static/front/images/category-list-new.svg'" alt="alt" style="width:17px"> <span>
                        {{getProjCategory(project.categories)}}
                      </span>
                    </aside>
                    <!--                <aside><i class="fas fa-list-ul"></i>{{project.categories[0].name}}</aside>-->
                    <aside><img :src="'/static/front/images/location-pin.svg'" alt="alt" style="width:17px"> {{project.country.name}}</aside>
                  </div>
                  <section>
                    <div class="row">
                      <div class="col-md-7">
                        <span v-if="project.impacts.length > 1">From </span><strong>US ${{ user ? (project.min_cost | currency) : '****' }} </strong>
                      </div>
                      <!-- <div class="col-md-5" v-if="user">
                        <div class="custConversionRate">
                          ≈AUD 0.294
                        </div>
                      </div> -->
                    </div>
                    <div class="custRecurringOverlay" :id="'cart' + project.id">
                      <button class="close" @click="openCard('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                      <div class="custAddImpactLevelSec">
                        <div class="impactLevelTitle">
                          <div class="inner">
                            Impact Level <span
                            v-tooltip.top="{ content: 'Select the level of impacts you want to create with this project.', class: 'normal-tooltip' }"
                            class="infopop" data-container="body" data-toggle="popover" style="vertical-align: top;line-height: normal;font-size: 0;padding-top: 0px;display: inline-block;"><img style="filter: brightness(0) invert(1);" src="/static/front/images/info-icon.svg" alt=""></span>
                          </div>
                        </div>
                        <select v-model="project.selectedImpact">
                          <option :value="null">Impact Level</option>
                          <option v-for="(impact) in project.impacts" v-bind:key="impact.id" :value="impact">US
                            ${{ impact.impact_level_cost|currency }} -
                            {{ impact.impact_level_title }}
                            ({{ impact.impact_unit }} - {{ impact.impact_unit == 1 ? 'Impact' : 'Impacts' }})
                          </option>
                        </select>
                        <div class="custAddtoCartBox">
                          <div class="qty-sec">
                            <input type="button" value="-" @click="decrease(project)">
                            <input type="text" :id="'qty' + project.id" :value="1">
                            <input type="button" value="+" @click="increase(project)">
                          </div>
                          <p :class="project.should_exclude != '1' ? 'btn-sec rml-10' : 'btn-sec'" style="display: inline-block;">
                            <button class="red-btn" @click="addToCart(project, project.selectedImpact)" :disabled="(user && user.role_id === 12)?true:false">
                              Add to cart
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="custRecurringOverlay" :id="'recurring' + project.id" style="display:none;">
                      <button class="close" @click="openCard('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                      <div class="custAddImpactLevelSec">
                        <div class="impactLevelTitle">
                          <div class="inner">
                            How would you like to proceed?
                          </div>
                        </div>
                        <div class="proceedOptions">
                          <a href="#" class="white-btn" @click="loadProjectModal(project, 'monthly')">Create Monthly Recurring Impacts</a>
                          <a href="#" class="red-btn" @click="loadProjectModal(project, 'manual')">Create Activity-based Impacts</a>
                        </div>
                      </div>
                    </div>
                    <div class="custProjectCardFooter" v-if="user">
                      <div class="tab" :id="'recurringBtn' + project.id" @click="openCard('recurring', project.id)" v-if="project.should_exclude != '1'">
                        <img :src="'/static/front/images/plus.svg'" alt="alt" style="width:17px">
                        Recurring Impacts
                      </div>
                      <div class="tab" :id="'addBtn' + project.id" @click="openCard('cart', project.id)">
                        <img :src="'/static/front/images/shopping_cart_icon_black.svg'" alt="alt" style="width:17px">
                        Add to Cart
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="project-more-sec owl-for-mobile" v-if="similarProjects.length">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h2>Other Similar Projects</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item" v-for="(project, index) in similarProjects" v-bind:key="index" :class="(index === 0) ? 'active' : ''" >
                    <div class="project-card">
                      <div class="cardSmallLinks">
                        <span v-if="user && globalProjectresp.indexOf(project.id) === -1" @click="fav(project, 0)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"
                        v-tooltip.top="{ content: 'Click on the heart to favourite', class: 'normal-tooltip' }"
                        class="infopop" data-container="body" data-toggle="popover"><i class="fas fa-heart"></i></span>
                        <router-link class="custViewDetailLink" :to="{ name: project.is_bundle == 0 ? 'projectdetail' : 'bundledetail', params: {id: project.id } }" id="project-details-detail"><span
                          v-tooltip.top="{ content: 'Click on the i or the project image to learn more about the project', class: 'normal-tooltip' }"
                          class="infopop" data-container="body" data-toggle="popover"><img :src="'/static/front/images/info-icon-black.svg'" alt="alt"></span></router-link>
                      </div>
                      <img v-if="project && project.image_rectangle" :src="getProjectImage(project.image_rectangle.image_name)" :id="'project_image_' + project.id" @error="onImageLoadFailure($event, 'project_image_' + project.id)" @click="redirectAnotherProject(project)" style="cursor: pointer" alt="alt">
                      <div class="card-text">
                        <h2>
                          <router-link class="" :to="{ name: project.is_bundle == 0 ? 'projectdetail' : 'bundledetail', params: {id: project.id } }" id="project-details-detail">
                            {{project.project_title}}
                          </router-link>
                        </h2>
                        <div class="cardCatMain">
                          <aside>
                            <img :src="'/static/front/images/category-list-new.svg'" alt="alt" style="width:17px"> <span>
                              {{getProjCategory(project.categories)}}
                            </span>
                          </aside>
                          <!--                <aside><i class="fas fa-list-ul"></i>{{project.categories[0].name}}</aside>-->
                          <aside><img :src="'/static/front/images/location-pin.svg'" alt="alt" style="width:17px"> {{project.country.name}}</aside>
                        </div>
                        <section>
                          <div class="row">
                            <div class="col-md-7">
                              <span v-if="project.impacts.length > 1">From </span><strong>US ${{ user ? (project.min_cost | currency) : '****' }}</strong>
                            </div>
                          </div>
                          <div class="custRecurringOverlay" :id="'cart-mobile' + project.id">
                            <button class="close" @click="openCardMobile('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                            <div class="custAddImpactLevelSec">
                              <div class="impactLevelTitle">
                                <div class="inner">
                                  Impact Level <span
                                  v-tooltip.top="{ content: 'Select the level of impacts you want to create with this project.', class: 'normal-tooltip' }"
                                  class="infopop" data-container="body" data-toggle="popover" style="vertical-align: top;line-height: normal;font-size: 0;padding-top: 0px;display: inline-block;"><img style="filter: brightness(0) invert(1);" src="/static/front/images/info-icon.svg" alt=""></span>
                                </div>
                              </div>
                              <select v-model="project.selectedImpact">
                                <option :value="null">Impact Level</option>
                                <option v-for="(impact) in project.impacts" v-bind:key="impact.id" :value="impact">US
                                  ${{ impact.impact_level_cost|currency }} -
                                  {{ impact.impact_level_title }}
                                  ({{ impact.impact_unit }} - {{ impact.impact_unit == 1 ? 'Impact' : 'Impacts' }})
                                </option>
                              </select>
                              <div class="custAddtoCartBox" v-if="user">
                                <div class="qty-sec">
                                  <input type="button" value="-" @click="decreaseMobile(project)">
                                  <input type="text" :id="'qty-mobile' + project.id" :value="1">
                                  <input type="button" value="+" @click="increaseMobile(project)">
                                </div>
                                <p :class="project.should_exclude != '1' ? 'btn-sec rml-10' : 'btn-sec'" style="display: inline-block;">
                                  <button class="red-btn" @click="addToCart(project, project.selectedImpact, 'mobile')" :disabled="(user && user.role_id === 12)?true:false">
                                    Add to cart
                                  </button>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="custRecurringOverlay" :id="'recurring-mobile' + project.id" style="display:none;">
                            <button class="close" @click="openCardMobile('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                            <div class="custAddImpactLevelSec">
                              <div class="impactLevelTitle">
                                <div class="inner">
                                  How would you like to proceed?
                                </div>
                              </div>
                              <div class="proceedOptions">
                                <a href="#" class="white-btn" @click="loadProjectModal(project, 'monthly')">Create Monthly Recurring Impacts</a>
                                <a href="#" class="red-btn" @click="loadProjectModal(project, 'manual')">Create Activity-based Impacts</a>
                              </div>
                            </div>
                          </div>
                          <div class="custProjectCardFooter" v-if="user">
                            <div class="tab" :id="'recurringBtn-mobile' + project.id" @click="openCardMobile('recurring', project.id)" v-if="project.should_exclude != '1'">
                              <img :src="'/static/front/images/plus.svg'" alt="alt" style="width:17px">
                              Recurring Impacts
                            </div>
                            <div class="tab" :id="'addBtn-mobile' + project.id" @click="openCardMobile('cart', project.id)">
                              <img :src="'/static/front/images/shopping_cart_icon_black.svg'" alt="alt" style="width:17px">
                              Add to Cart
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <i class="fas fa-chevron-left"></i>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <i class="fas fa-chevron-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top:15px;">
            <div class="col-md-12 d-flex justify-content-center">
            </div>
          </div>
        </div>
      </section>
      <modal name="image-details-modal" id="image-details-modal" transition="pop-out" :width="1100" :adaptive="true" :maxWidth="900" height="auto" :scrollable="true">
        <div class="modal-content">
          <div class="modal-head">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$modal.hide('image-details-modal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="detailedProjectImage">
            <div class="yes-sec text-center">
              <img class="project-details-image" style="" :src="detailedProjectImage" alt="alt">
            </div>
          </div>
        </div>
      </modal>
      <!-- none global and none bundle project warning pop up  -->
      <modal name="non-global-warning-modal" id="non-global-warning-modal" transition="pop-out" width="560" :adaptive="true" height="auto" :scrollable="true" style="overflow: visible !important;" :maxWidth="560"  :clickToClose="false">
        <div class="modal-content">
          <div class="modal-body" style="padding:35px;">
            <section>
              <h3>TIP</h3>
              <div>
<!--               <p>When selecting projects for the long-term, we recommend considering B1G1's Global Projects for sustainability and stability! Learn more <a href="https://b1g1.zendesk.com/hc/en-us/articles/900006802423-Why-do-some-B1G1-projects-get-paused-and-what-s-the-impact-of-it-" target="_blank">here </a></p>-->
                <p>When selecting projects for the long-term, we recommend considering B1G1's Global Projects for sustainability and stability! Learn more <a href="https://b1g1.helpscoutdocs.com/article/97-about-global-projects#usage" target="_blank">here </a></p>
              </div>
              <div>
                <p>Examples of Global Projects</p>
                <!-- <div class="col-md-3" v-for="(imgpath, index) in globalProjectImages" :key="index">
                  <img :src="imgpath">
                </div> -->
                <div class="row">
                  <div class="col-md-4 col-xs-8 mt-1" v-for="(imgpath, index) in globalProjectImages" :key="index">
                    <img :src="imgpath" alt="alt">
                  </div>
                </div>
              </div>
              <div class="row mt-4 dont-show-bt">
                <div class="text-left col-md-6 col-xs-3 mob-center">
                  <button class="b-btn red-btn red-btn1 mt-3 dont-show-bt" @click="updateWarningMsgFlag(selectedProject)">DON’T SHOW ME AGAIN</button>
                </div>
                <div :class="isMobile ? 'col-xs-3 mob-center' : 'text-right col-md-6'">
                  <button class="b-btn white-btn white-btn1 mt-3" @click="createGivingStory(selectedProject)">CLOSE</button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import store from '../../store'
import appAPI from '../../api/app'
import userAPI from '../../api/user'
import updateAPI from '../../api/update'
import projectAPI from '../../api/project'
import introJsAPI from '../../api/userintrojs'
import Datepicker from 'vuejs-datepicker'
import config from '../../config/app'
import vmodal from 'vue-js-modal'
import moment from 'moment'
import NotificationMixin from '../../helper/mixin/Notification'
import introJs from 'intro.js'
import 'intro.js/introjs.css'
import Vue from 'vue'

Vue.use(vmodal)

export default {
  beforeRouteEnter (to, from, next) {
    let prevUrl = from.path
    next(vm => vm.setPrevUrl(prevUrl))
  },
  mixins: [NotificationMixin],
  data () {
    return {
      user: store.getters.currentUser,
      isMobile: store.getters.isMobile,
      project: [],
      isrestrictState: false,
      restrictState: config.restricted_states,
      similarProjects: [],
      partners: [],
      host: config.host,
      isAdminLogin: false,
      story: {show_share1: false, show_share2: false, description1: '', description2: ''},
      order: 'small_cost_asc',
      urlFilters: 'status=live',
      detailedProjectImage: null,
      arrowFlag: 0,
      selectedDate: '',
      favProjects: [],
      allProjects: [],
      categories: [],
      countries: [],
      user_state: null,
      selectedImpactLevel: [],
      filters: {
        page: 1,
        limit: (/iPad|iPod/i.test(navigator.userAgent)) ? 3 : 4,
        category_ids: [],
        country_ids: [],
        not_project_id: 0
      },
      display: {
        type: 'all',
        loaded: false,
        loading: false,
        saiving: true
      },
      detailedProject: null,
      story_text: null,
      showProfilePage: 1,
      approvedUpdates: [],
      projectUpdate: [],
      pendingUpdates: [],
      defaultImage: '/static/logos/b1g1-light-widget.png',
      introjsData: [],
      prevUrl: '',
      variousWcId: config.wcuser_id,
      scrollHeight: 15,
      globalProjectresp: [],
      globalProjectImages: [],
      selectedProject: [],
      recurringType: 'manual',
      currentTime: moment.now()
    }
  },
  methods: {
    loadHelpScout () {
      userAPI.geHelpScot().then((response) => {
        if (response) {
          window.Beacon('init', '0b17bdca-a9c7-4192-8a1e-1f2c5ea92da0')
          window.Beacon('config', {enableFabAnimation: false})
          window.Beacon('identify', {
            // name: this.user.first_name + ' ' + this.user.last_name,
            // email: this.user.email,
            name: response.name,
            email: response.email,
            'user_id': response.user_id,
            'role_id': response.role_id,
            'account_view_type': response.account_view_type,
            'company_number_of_referrals': response.company_number_of_referrals,
            'company_total_number_of_giving': response.company_total_number_of_giving,
            'company_join_date': response.company_join_date,
            'company_last_giving_date': response.company_last_giving_date,
            'company_has_ever_created_giving_story': response.company_has_ever_created_giving_story,
            'company_has_ever_favourited_project': response.company_has_ever_favourited_project,
            'company_last_login_date': response.company_last_login_date,
            'company_total_number_of_impacts': response.company_total_number_of_impacts,
            'company_country': response.company_country,
            'company_referral_status': response.company_referral_status,
            'company_membership_package': response.company_membership_package,
            'personal_total_number_of_giving': response.personal_total_number_of_giving,
            'personal_join_date': response.personal_join_date,
            'personal_last_giving_date': response.personal_last_giving_date,
            'personal_has_ever_created_giving_story': response.personal_has_ever_created_giving_story,
            'personal_has_ever_favourited_project': response.personal_has_ever_favourited_project,
            'personal_last_login_date': response.personal_last_login_date,
            'personal_total_number_of_impacts': response.personal_total_number_of_impacts
          })
          if (this.isAdminLogin === false) {
            // window.webpushr('attributes', {'user_id': response.user_id, 'role_id': response.role_id, 'account_view_type': response.account_view_type, 'company_last_projects_given': response.company_last_projects_given, 'company_last_giving_date': response.company_last_giving_date, 'company_last_login_date': response.company_last_login_date, 'company_total_number_of_impacts': response.company_total_number_of_impacts, 'company_membership_package': response.company_membership_package, 'personal_last_projects_given': response.personal_last_projects_given, 'personal_last_giving_date': response.personal_last_giving_date, 'personal_last_login_date': response.personal_last_login_date, 'personal_total_number_of_impacts': response.personal_total_number_of_impacts, 'personal_current_login_date': response.personal_current_login_date, 'company_current_login_date': response.company_current_login_date})
          }
        }
      })
    },
    setPrevUrl (prevUrl) {
      this.prevUrl = prevUrl
    },
    setSegmentPageData (prevUrl) {
      if (this.user) {
        userAPI.setSegmentPageDetails(this.user ? this.user.id : 0, document.title, document.location.href, document.location.protocol + '//' + document.location.host + prevUrl)
      }
    },
    changeDate (index = '', projectUpdate) {
      if (index !== '') {
        if (this.arrowFlag < index) {
          this.scrollHeight = 15 + (30 * index)
        } else {
          this.scrollHeight = 15 - (30 * index)
        }
      }
      this.arrowFlag = index
      this.selectedDate = projectUpdate
      this.projectUpdate = projectUpdate
    },
    moveProjectUpdate (action) {
      let el = document.getElementById('project_date')
      if (action === 'up') {
        this.arrowFlag -= 1
        this.scrollHeight = this.scrollHeight - 30
        el.scrollTop = this.scrollHeight - 30
      } else if (action === 'down') {
        this.arrowFlag += 1
        this.scrollHeight = this.scrollHeight + 30
        el.scrollTop = this.scrollHeight + 30
      }
      this.selectedDate = this.approvedUpdates[this.arrowFlag]
      this.projectUpdate = this.approvedUpdates[this.arrowFlag]
    },
    getUpdatedText (text) {
      text = text.replace(/\\r\\n/g, '<br/>')
      text = text.replace("\\'", "'")
      text = text.replace('\\\\', '\\')
      if (text.length > 1000) {
        text = text.substring(0, 1000) + '...'
      }
      return text
    },
    onImageLoadFailure (event, id, type = null) {
      if (type === 'wc') {
        console.log(this.projectUpdate.project_image)
        document.getElementById(id).src = this.projectUpdate.project_image
      }
      document.getElementById(id).src = this.defaultImage
    },
    onImageLoadFailureWC (event, id) {
      document.getElementById(id).src = this.projectUpdate.project_image
    },
    loadProjectDetails () {
      projectAPI.getById(this.$route.params.id, ['Country.Region', 'Country', 'Categories', 'Beneficiaries', 'ImageSquare', 'ImageRectangle', 'Impacts', 'ImpactCategory', 'User', 'Goals', 'PartnerUser']).then((response) => {
        let projectData = response
        document.title = (projectData.project_title) ? projectData.project_title : 'Project Detail'
        this.setSegmentPageData(this.prevUrl)
        if (projectData) {
          if (projectData.is_bundle === '0') {
            this.project = response
            this.selectDetailedProject(this.project)
            let minCost = null
            this.project.impacts = (this.project === undefined) ? null : projectAPI.commonImpactDataFilter(this.project.impacts)
            if (this.project.impacts) {
              this.selectedImpactLevel = this.project.impacts[0]
            }
            // restrict to the california user to access wc project whoes monthly remittance status is no
            if (projectData.partner_user) {
              if (this.user_state === 'California' && projectData.partner_user.monthly_remittance === 'no') {
                window.location.href = this.host + '/view-all-projects'
              }
            }
            this.project.impacts.forEach((impact) => {
              if (impact.impact_level_cost < minCost || minCost === null) {
                minCost = impact.impact_level_cost
                this.project.current_impact = impact
              }
            })
            // If story text is not blank
            if (this.project.story !== null) {
              this.project.story = JSON.parse(this.project.story)
              if (this.project.story !== null) {
                if (this.project.story.story_text !== 'null' || this.project.story.story_text !== null) {
                  this.story_text = this.project.story.story_text
                }
              }
            }
            this.project.min_cost = minCost
            this.filters.country_ids.push(this.project.country_id)
            if (this.project.categories.length > 0) {
              this.project.categories.forEach((category) => {
                this.filters.category_ids.push(category.id)
              })
            }
            // this.loadProjects(this.filters)
            this.loadSimilarProjects(this.filters)
            this.loadUpdates()
          } else {
            window.location.href = this.host + '/view-all-projects'
          }
        }
      })
    },
    // Used new function: loadSimilarProjects
    loadProjects (filters) {
      let arrprojects = []
      this.display.loadedTableData = false
      return new Promise((resolve, reject) => {
        filters.is_company = store.getters.isCompanyAccount ? 1 : 0
        projectAPI.newGetProjects(filters, ['ImageSquare', 'ImageRectangle', 'Country', 'Impacts', 'Categories'], this.urlFilters, this.user).then((response) => {
          if (response) {
            this.display.loaded = true
            let filteredProjects = response.data
            this.meta = response.meta
            let filterIds = response.filters
            for (let key in filterIds) {
              this.filters[key] = filterIds[key]
            }
            filteredProjects.forEach((project) => {
              let minCost = null
              project.impacts = projectAPI.commonImpactDataFilter(project.impacts)
              project.impacts.forEach((impact) => {
                if (this.filters.min_cost && impact.impact_level_cost < this.filters.min_cost) {
                  return
                }
                if (this.filters.max_cost && impact.impact_level_cost > this.filters.max_cost) {
                  return
                }
                if (impact.impact_level_cost < minCost || minCost === null) {
                  minCost = impact.impact_level_cost
                  project.current_impact = impact
                }
              })
              if (minCost !== null) {
                project.min_cost = minCost
                arrprojects.push(project)
              }
            })
            this.similarProjects = arrprojects
            // this.sortProjects()
          }
          resolve(arrprojects)
        })
      })
    },
    loadSimilarProjects (filters) {
      let arrprojects = []
      return new Promise((resolve, reject) => {
        projectAPI.getSimilarProjects(this.project.id, filters, ['ImageSquare', 'ImageRectangle', 'Country', 'Impacts', 'Categories'], this.urlFilters, this.user).then((response) => {
          if (response) {
            response.forEach((project) => {
              if (project.id !== parseInt(this.$route.params.id)) {
                let minCost = null
                project.impacts = projectAPI.commonImpactDataFilter(project.impacts)
                project.selectedImpact = (project.impacts && project.impacts.length) ? project.impacts[0] : null
                project.impacts.forEach((impact) => {
                  if (impact.impact_level_cost < minCost || minCost === null) {
                    minCost = impact.impact_level_cost
                    project.current_impact = impact
                  }
                })
                project.min_cost = minCost
                arrprojects.push(project)
              }
            })
            this.similarProjects = arrprojects
          }
          this.display.loaded = true
          resolve(arrprojects)
        })
      })
    },
    loadUpdates () {
      this.approvedUpdates = []
      this.pendingUpdates = []
      return updateAPI.getUpdatesByUserId(this.project.user_id, ['Projects', 'User.UserPartner']).then((response) => {
        response.data.forEach((update) => {
          if (update.status === 1 && update.projects[0]) {
            let data = {
              id: update.id,
              project_id: update.projects[0].id,
              image: update.images[0],
              images: update.images,
              video: update.video,
              project_text: update.text,
              project_image: update.projects[0].project_image,
              project_title: (update.projects.length > 1) ? 'Update from ' + update.user.user_partner.org_name : update.projects[0].project_title,
              date: moment(update.date).format('DD MMM\' YYYY'),
              created_at: moment(update.created_at).format('DD MMM\' YYYY')
            }
            if (data.images) {
              let sliderimages = []
              data.images.forEach((item) => {
                let images = {}
                images.type = 'image'
                images.link = item
                sliderimages.push(images)
              })
              data.sliderimages = sliderimages
            }
            this.approvedUpdates.push(data)
          } else {
            this.pendingUpdates.push(update)
          }
        })
        if (this.approvedUpdates.length > 0) {
          this.projectUpdate = this.approvedUpdates[0]
          this.selectedDate = this.approvedUpdates[0]
        }
      })
    },
    loadfavProjects () {
      if (this.user !== null) {
        return projectAPI.getFavProjects(this.user.id, undefined, {
          status: 'live',
          project_approved: 1,
          is_company: store.getters.isCompanyAccount
        }).then((response) => {
          response.forEach((project) => {
            this.favProjects.push(project.id)
          })
        })
      } else {
        return true
      }
    },
    getProjectImage (img) {
      if (!img) {
        return this.host + this.defaultProjectImg
      } else {
        return img
      }
    },
    getPartnerName (id) {
      return this.partners.filter(i => i.id === id).length > 0 ? this.partners.filter(i => i.id === id)[0].user_partner.org_name : ''
    },
    getCountryName (id) {
      return this.countries.filter(i => i.id === id).length > 0 ? this.countries.filter(i => i.id === id)[0].name : ''
    },
    getPartnerUrl (id) {
      // this.showProfilePage = this.partners.filter(i => i.id === id).length > 0 ? this.partners.filter(i => i.id === id)[0].user_partner.show_profile_page : '1'
      this.showProfilePage = 1
      return this.partners.filter(i => i.id === id).length > 0 ? this.host + '/wcu_partner/' + this.partners.filter(i => i.id === id)[0].user_partner.id : ''
    },
    selectDetailed (image) {
      this.detailedProjectImage = image
      this.$modal.show('image-details-modal')
    },
    fav (project, flag) {
      this.display.loading = true
      let projectId = project.id
      let index = this.favProjects.indexOf(projectId)
      let projectType = (index !== -1) ? 'remove' : 'add'
      projectAPI.favProject(this.user.id, projectId, store.getters.isCompanyAccount, projectType).then((response) => {
        this.display.loading = false
        if (index !== -1) {
          this.favProjects.splice(index, 1)
          if (document.getElementById(projectId)) {
            document.getElementById(projectId).classList.remove('red-heart')
          }
          if (flag === 0) {
            this.bToast('success', 'Project removed from Favorites.')
          } else {
            this.bToast('success', 'Project removed from Suggested Projects.')
          }
          project.is_favorite = 0
          if (this.favProjects.length === 0) {
            setTimeout(function () {
              window.location.reload()
            }, 800)
          }
        } else {
          project.is_favorite = 1
          this.favProjects.push(projectId)
          if (document.getElementById(projectId)) {
            document.getElementById(projectId).classList.add('red-heart')
          }
          if (flag === 0) {
            this.bToast('success', 'Project added to Favorites.')
          } else {
            this.bToast('success', 'Project added to Suggested Projects.')
          }
        }
      })
    },
    isFav (projectId) {
      return this.favProjects.indexOf(projectId) === -1
    },
    getProjImage (imgName) {
      if (!imgName) {
        return null
      } else {
        if (imgName) {
          return imgName.image_name + '?' + this.currentTime
        }
      }
    },
    selectDetailedProject (project) {
      this.detailedProject = project
      if (project.impacts.length > 0) {
        this.selectedImpactLevel = project.impacts[0]
      }
    },
    openCard (card, id) {
      console.log('ggggggg')
      console.log(card)
      if (card === 'recurring') {
        const recurring = document.getElementById('recurring' + id)
        recurring.style.display = 'flex'
        const cart = document.getElementById('cart' + id)
        cart.style.display = 'none'
        const addBtn = document.getElementById('addBtn' + id)
        addBtn.classList.remove('active')
        const recurringBtn = document.getElementById('recurringBtn' + id)
        recurringBtn.classList.add('active')
      } else if (card === 'close') {
        const recurring = document.getElementById('recurring' + id)
        recurring.style.display = 'none'
        const cart = document.getElementById('cart' + id)
        cart.style.display = 'none'
        const addBtn = document.getElementById('addBtn' + id)
        addBtn.classList.remove('active')
        const recurringBtn = document.getElementById('recurringBtn' + id)
        recurringBtn.classList.remove('active')
      } else {
        const recurring = document.getElementById('recurring' + id)
        recurring.style.display = 'none'
        const cart = document.getElementById('cart' + id)
        cart.style.display = 'flex'
        const addBtn = document.getElementById('addBtn' + id)
        addBtn.classList.add('active')
        const recurringBtn = document.getElementById('recurringBtn' + id)
        recurringBtn.classList.remove('active')
      }
    },
    openCardMobile (card, id) {
      if (card === 'recurring') {
        const recurring = document.getElementById('recurring-mobile' + id)
        recurring.style.display = 'flex'
        const cart = document.getElementById('cart-mobile' + id)
        cart.style.display = 'none'
        const addBtn = document.getElementById('addBtn-mobile' + id)
        addBtn.classList.remove('active')
        const recurringBtn = document.getElementById('recurringBtn-mobile' + id)
        recurringBtn.classList.add('active')
      } else if (card === 'close') {
        const recurring = document.getElementById('recurring-mobile' + id)
        recurring.style.display = 'none'
        const cart = document.getElementById('cart-mobile' + id)
        cart.style.display = 'none'
        const addBtn = document.getElementById('addBtn-mobile' + id)
        addBtn.classList.remove('active')
        const recurringBtn = document.getElementById('recurringBtn-mobile' + id)
        recurringBtn.classList.remove('active')
      } else {
        const recurring = document.getElementById('recurring-mobile' + id)
        recurring.style.display = 'none'
        const cart = document.getElementById('cart-mobile' + id)
        cart.style.display = 'flex'
        const addBtn = document.getElementById('addBtn-mobile' + id)
        addBtn.classList.add('active')
        const recurringBtn = document.getElementById('recurringBtn-mobile' + id)
        recurringBtn.classList.remove('active')
      }
    },
    increase (project) {
      const qty = document.getElementById('qty' + project.id)
      if (qty.value < 1000000 && qty.value > 0) {
        qty.value++
      } else {
        qty.value = 1
      }
      // this.updateQuantity(project)
    },
    decrease (project) {
      const qty = document.getElementById('qty' + project.id)
      if (qty.value !== '1' && qty.value > 0) {
        qty.value--
      } else {
        qty.value = 1
      }
    },
    increaseMobile (project) {
      const qty = document.getElementById('qty-mobile' + project.id)
      if (qty.value < 1000000 && qty.value > 0) {
        qty.value++
      } else {
        qty.value = 1
      }
      // this.updateQuantity(project)
    },
    decreaseMobile (project) {
      const qty = document.getElementById('qty-mobile' + project.id)
      if (qty.value !== '1' && qty.value > 0) {
        qty.value--
      } else {
        qty.value = 1
      }
    },
    addToCart (project, impact, device = null) {
      this.display.loading = true
      if (this.user !== null) {
        let qty = document.getElementById('qty' + project.id)
        if (device !== null) {
          qty = document.getElementById('qty-mobile' + project.id)
        }
        store.dispatch('addToGivingCart', {
          projectId: project.id,
          impactId: impact.id,
          type: 'project',
          user_id: this.user.id,
          company_id: this.user.account === 'company' && this.user.user_business && this.user.user_business.company_id ? this.user.user_business.company_id : null,
          impact_level_id: impact.id,
          amt_total_usd: impact.impact_level_cost,
          count: qty.value,
          story_group_id: null,
          beneficiaries: impact.impact_unit,
          single_contribution_total: impact.impact_level_cost
        }).then(() => {
          this.display.loading = false
          if (this.favProjects.length > 0) {
            document.getElementById('cartnumber').classList.add('cart-animate')
            setTimeout(function () {
              document.getElementById('cartnumber').classList.remove('cart-animate')
            }, 400)
          }
          this.bToast('success', 'Item added to cart.')
        })
      } else {
        this.display.loading = false
        return true
      }
    },
    updateIntrojsData (getPage) {
      // Update Introjs details for create giving story
      let data = []
      if (getPage === 'display_project_modal') {
        data = {'display_project_modal': '1'}
      } else {
        data = {'project': '1'}
      }
      introJsAPI.update(data).then((response) => {
        if (getPage === 'project') {
          introJsAPI.check().then((response) => {
            this.display.saiving = false
            this.introjsData = response
          })
        }
      })
    },
    redirectAnotherProject (project) {
      let url = config.host + (parseInt(project.is_bundle) === 0 ? '/projectdetail/' : '/bundledetail/') + project.id
      window.open(url, '_blank')
    },
    getYoutubeThumbnail (url) {
      // get thumbnail image for youtube video url
      var imgUrl = ''
      if (url.match(/[\w-]{11,}/)) {
        var youtubeID = url.match(/[\w-]{11,}/)[0]
        imgUrl = `http://i1.ytimg.com/vi/${youtubeID}/0.jpg`
      } else {
        // get thumbnail image for vimeo player url
        var imgDet = url.split('/')
        imgUrl = 'https://vumbnail.com/' + imgDet[imgDet.length - 1] + '_medium.jpg'
      }
      return imgUrl
    },
    openYoutubeVideo (url) {
      window.open(url, '_blank')
    },
    updateWarningMsgFlag (project) {
      this.updateIntrojsData('display_project_modal')
      this.createGivingStory(project)
    },
    loadProjectModal (project, type) {
      if (this.introjsData.display_project_modal === '0' && project.is_bundle !== '1' && project.country.name !== 'Global') {
        this.selectedProject = project
        this.recurringType = type
        this.$modal.show('non-global-warning-modal')
      } else {
        this.recurringType = type
        this.createGivingStory(project)
      }
    },
    createGivingStory (project) {
      if (!this.display.saiving) {
        if (this.user) {
          userAPI.setSegmentDetails({ 'user_id': this.user.id, 'type': 'giving_story', 'project_id': project.id })
        }
        if (this.isFav(project.id) === true) {
          this.fav(project, 1)
        }
        let currentThis = this
        setTimeout(function () {
          currentThis.$router.push({name: 'create-recurring-impacts', params: { project_id: project.id, type: currentThis.recurringType }})
        }, 700)
      }
    },
    getGlobalProjectImage (projectId) {
      projectAPI.getById(projectId, ['ImageRectangle']).then((response) => {
        this.globalProjectImages.push(response.image_rectangle.image_name)
      })
    },
    getProjCategory (category) {
      return category.map(item => item.name).join(', ')
    },
    getProjCountry (country, index) {
      return country.name
    }
  },
  destroyed () {
    window.Beacon('destroy')
  },
  created () {
    if (localStorage.getItem('login_user_type') !== '' && localStorage.getItem('login_user_type') === 'admin') {
      this.isAdminLogin = true
    }
    // code for california state hide WC sections
    if (this.user !== null) {
      if (this.user.companydata) {
        if (this.restrictState && this.restrictState.includes(this.user.companydata.state)) {
          this.isrestrictState = true
        } else {
          this.isrestrictState = false
        }
      }
      if (this.user.account === 'company') {
        if (this.user.companydata) {
          this.user_state = this.user.companydata.state
        }
      } else if (this.user.account === 'user') {
        if (this.user.user_business) {
          this.user_state = this.user.user_business.state
        }
      }
    }
    // End Wc hide section for california
    // this.variousWcId = (process.env.NODE_ENV === 'production') ? 13217 : 13192
    this.filters.not_project_id = this.$route.params.id
    this.display.loading = true
    projectAPI.getValidProject(this.$route.params.id).then((response) => {
      let isValidProject = response
      if (isValidProject === 1) {
        let projectDetailsPromise = this.loadProjectDetails()
        let partnersPromise = userAPI.get({
          'type': 'partner',
          'status': 'active',
          'blocked': 'no',
          'limit': '-1'
        }, ['UserPartner']).then((response) => {
          this.partners = response
        })
        let countriesPromise = appAPI.getCountries().then((response) => {
          this.countries = response
        })
        let favoriteProjectPromise = this.loadfavProjects()
        let userIntrojsPromise = null
        if (this.user) {
          if (this.user.type === 'business') {
            userIntrojsPromise = introJsAPI.check().then((response) => {
              this.introjsData = response
            }).catch(() => {})
          }
        }
        let globalprojectPromise = projectAPI.getGlobalProjects().then((response) => {
          if (response.length > 0) {
            response.forEach((projectId) => {
              this.globalProjectresp.push(projectId)
              this.getGlobalProjectImage(projectId)
            })
          }
        })
        let loadHelpScoutPromise = this.loadHelpScout()
        Promise.all([projectDetailsPromise, loadHelpScoutPromise, partnersPromise, countriesPromise, userIntrojsPromise, favoriteProjectPromise, globalprojectPromise]).then(() => {
          // window.Beacon('init', '66c2695d-5e75-4749-aa45-d0a1429b082d')
          // if (this.user) {
          //   window.Beacon('identify', {
          //     name: this.user.first_name + ' ' + this.user.last_name,
          //     email: this.user.email
          //   })
          // }
          let currentThis = this
          this.display.loading = false
          this.display.loaded = true
          if (this.user && this.user.type === 'business' && this.introjsData.project !== '1') {
            this.display.saiving = true
            setTimeout(function () {
              let getDiv = document.getElementById('add-to-btn')
              if (getDiv) {
                getDiv.setAttribute('data-step', '1')
                getDiv.setAttribute('data-intro', 'The magic is just about to begin! Create a recurring impacts for this project now to embed giving into your business.')
              }
              introJs().setOption('showBullets', false).setOption('showStepNumbers', false).setOption('skipLabel', 'Skip tutorial').setOption('prevLabel', '<<').setOption('nextLabel', '>>').setOption('doneLabel', 'GOT IT').setOption('hidePrev', true).setOption('hideNext', true)
                .start()
                .oncomplete(function () {
                  // clicking 'Done'
                  currentThis.updateIntrojsData('project')
                })
                .onexit(function () {
                  // clicking 'Skip'
                  currentThis.updateIntrojsData('project')
                })
            }, 1000)
          } else {
            this.display.saiving = false
          }
        })
      } else {
        window.location.href = this.host + '/view-all-projects'
      }
    })
  },
  components: {
    Datepicker
  }
}
</script>

<style scoped>
  .vue-tooltip-visible {
    z-index: 9999 !important;
  }
  .impact-feed-img{
    height: 80px;
    width: 80px;
  }
  .sdg-sec img{
    width:50px;
  }
  .project-sec img{
    width:60px;
  }
  aside h3 {
    text-transform: none;
  }
  .card-text h2 {
    text-transform: none !important;
  }
  .sdg-sec img {
    width: 25px;
  }
  .img-row .media {
    width: 30%;
    height: 100%;
  }
  .img-row .media iframe{
    width: 100%;
  }
  .time-sec img{
    filter: drop-shadow(12px 12px 0px #FF9942);
    -webkit-filter: drop-shadow(12px 12px 0px #FF9942);
    border-radius: 5px;
    background: #fff;
  }
  .timeContent{
    padding-left: 30px;
  }
  .timeContent h3{
    font-size: 22px;
    margin: 0 0 30px;
  }
  .timeContent h3 span.updateDate {
    display: block;
    font-size: 14px;
    font-style: italic;
    margin: 5px 0 0;
  }
  .timeContent strong{
    font-weight: 500 !important;
  }
  .card-text aside {
    text-align: left;
  }
  #project-detailed .dark-section-2 {
    margin: 0;
    padding: 0;
  }
  .modal-img{
    text-align: center;
  }
  .modal-img .project-details-image{
    width: 100%;
  }

  .img-row .media {
    position: relative;
  }
  .img-row .media .play_icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 30%;
  }
  .img-row .media img {
    width: 100%;
    cursor: pointer;
  }
  .red-btn1{
    background: #fff !important;
    color: #000000 !important;
    border: 1px solid #ddd !important;
    border-radius: 0px !important;
  }
  .white-btn1{
    background: #F6511D;
    color: #fff !important;
  }
  .rml-10{
    margin-left: 10px;
  }
  .projectDetailsLeftSec {
    padding-right: 60px;
  }
  .projectDetailsLeftSec .tags {
    display: flex;
    gap: 4px;
    align-items: flex-start;
    margin: 0 0 8px;
  }
  .projectDetailsLeftSec .tags:last-child {
    margin: 0;
  }
  .projectDetailsLeftSec .tags .icon {
    display: flex;
    align-items: flex-start;
    flex: 0 0 17px;
  }
  .projectDetailsLeftSec .tags .tag-text {
    line-height: 1.2;
  }
  .project-more-sec{
    text-align: left;
  }
  .project-detail-sec h2{
    text-transform: none !important;
  }
  .custProjectBySec {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 15px;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .custProjectBySec p {
    margin: 0;
    line-height: 1.3;
  }
  .custProjectBySec p strong {
    display: block;
    font-weight: 500 !important;
  }
  .custProjectBySec .heart-icon {
    border-radius: 5px;
  }
  .custProjectBySec .heart-icon.red-heart{
    background: #FF1254;
    color: #fff;
  }
  .custProjectBySec .heart-icon i.fas {
    font-size: 18px;
    line-height: 30px;
  }
  .project-more-sec p.sdg-sec {
    padding: 6px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    width: auto !important;
    max-width: none;
    display: inline-flex;
    gap: 4px;
    margin-top: 20px;
  }
  .project-more-sec p.sdg-sec span#invite-css-tooltip{
    font-size: 0;
  }
  .project-more-sec p.sdg-sec span#invite-css-tooltip img {
    margin: 0;
  }
  .project-more-sec .projectDetailsLeftSec h2 {
    font-size: 32px;
    margin: 0 0 20px;
  }
  .custAddImpactLevelSec{
    max-width: 100%;
  }
  .custAddImpactLevelSec .impactLevelTitle {
    display: flex;
    align-items: center;
    gap: 5px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;
    margin: 0 0 8px;
  }
  .custAddImpactLevelSec select#impactlevel {
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    height: auto;
    font-size: 16px;
    line-height: 1;
    margin: 0 0 10px;
  }
  .custAddImpactLevelSec .custAddtoCartBox {
    display: flex;
    align-items: center;
    margin: 0 0 10px;
    gap: 10px;
  }
  .custAddImpactLevelSec .custAddtoCartBox .qty-sec {
    height: 40px;
    width: 120px;
  }
  .custAddImpactLevelSec .custAddtoCartBox .qty-sec input[type="text"] {
      width: 60px;
  }
  .custAddImpactLevelSec .custAddtoCartBox .qty-sec input[type="button"] {
      width: 30px;
  }
  .custAddImpactLevelSec .custAddtoCartBox p {
    margin: 0;
    width: 100%;
  }
  .custAddImpactLevelSec .custAddtoCartBox p button{
    width: 100%;
    border: 0;
  }
  .custAddImpactLevelSec .add-to-f-btn a#create_giving__btn,
  .custAddImpactLevelSec .add-to-f-btn,
  .custAddImpactLevelSec .pro-btn {
    width: 100%;
    text-align: center;
  }
  .custAddImpactLevelSec .add-to-f-btn a#create_giving__btn{
    background: #F9F9F9;
  }
  .custAddImpactLevelSec .add-to-f-btn a#create_giving__btn:hover{
    background: #16162E;
    color: #fff;
  }
  .project-more-sec .project-card {
    max-width: 100% !important;
    margin: 0 !important;
  }
  .project-more-sec .project-card img[id*="project_image_"]{
    object-fit: cover;
    width: 100%;
    /* height: 180px; */
    max-width: 100%;
    float: none;
  }
  .project-timeline-sec .time-sec{
    width: 100%;
    padding: 40px;
  }
  .project-timeline-sec .time-sec h2{
    text-align: left !important;
    text-transform: none !important;
    font-size: 24px;
    margin: 0;
  }
  .project-timeline-sec .time-sec ul{
    display: none !important;
  }
  .project-timeline-sec .time-sec .carousel-item {
    padding-right: 12px;
    padding-bottom: 12px;
  }
  .timeTop {
    display: flex;
    width: 100%;
    align-items: center;
    margin: 0 0 25px;
  }
  .timeTop aside {
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 5px;
  }
  .timeTop aside [class*="-arrow"] {
    margin: 0;
    display: flex;
    background: #FF9942;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
  }
  .custImageGallery {
    display: flex;
    gap: 20px;
    width: 100%;
    overflow: auto;
    margin: 0 0 30px;
    padding: 0 0 10px;
    justify-content: space-evenly;
  }
  .custImageGallery .imgBox {
      padding-top: 270px;
      flex: 0 0 40%;
      position: relative;
      overflow: hidden;
  }
  .custImageGallery .imgBox img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .custImageGallery .imgBox.videoBox iframe {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: 0;
    outline: none;
  }
  .custImageGallery .imgBox.videoBox .play_icon {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
  }
  .custImageGallery .imgBox.videoBox .play_icon img {
    height: 32px;
    width: auto;
    position: unset;
  }
  .custImageGallery::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
    height: 5px;
  }
  /* Track */
  .custImageGallery::-webkit-scrollbar-track {
    background: #ECECEC;
    border-radius: 5px;
  }
  /* Handle */
  .custImageGallery::-webkit-scrollbar-thumb {
    background: #47BFEE;
    cursor: pointer;
    border-radius: 5px;
  }

  @media(max-width: 1024px){
    .projectDetailsLeftSec{
      padding-right: 20px;
    }
    .custAddImpactLevelSec .custAddtoCartBox p button{
      padding: 8px 5px;
    }
  }
  @media(max-width: 991px){
    .custImageGallery .imgBox{
      flex: 0 0 50%;
      padding-top: 220px;
    }
    .project-more-sec .project-card{
      margin: 0 0 30px !important;
      width: 100%;
    }
    .project-card .card-text .custProjectCardFooter{
      margin: 10px -10px -10px;
    }
  }
  @media(max-width: 767px){
    .project-timeline-sec .time-sec{
      padding: 20px;
    }
    #carouselExampleControls.project-img-slide{
      margin-bottom: 20px;
    }
    .timeContent{
      padding-left: 0;
    }
    .projectDetails{
      padding-right: 0;
    }
    .timeContent .read-btn{
      text-align: left;
    }
    .projectDetailsLeftSec {
      padding-right: 0px;
      margin-bottom: 20px;
    }
    .custAddImpactLevelSec .pro-btn{
      margin: 10px 0 0;
    }
    .project-more-sec .projectDetailsLeftSec h2{
      font-size: 24px;
      margin: 0 0 15px;
      text-align: left;
    }
    .project-detail-sec-main.project-more-sec{
      padding-top: 25px;
    }
    .custImageGallery{
      margin: 0 0 15px;
    }
    .custImageGallery .imgBox{
      flex: 0 0 100%;
      padding-top: 220px;
    }
    .project-timeline-sec h2{
      font-size: 22px !important;
    }
    .timeContent h3{
      margin: 30px 0;
    }
    .project-card .card-text .custProjectCardFooter{
      margin: 10px -15px -15px;
    }
    .project-more-sec .carousel-item .project-card .card-text section {
      max-width: unset;
    }
    .project-more-sec .carousel-item .project-card .card-text h2{
      text-align: left;
    }
  }
  @media (max-width: 480px) {
    .rmt-30{
      margin-top: 0px !important;
    }
    .timeTop{
      flex-direction: column;
    }
    .timeTop aside{
      margin-left: 0;
      align-items: flex-start;
    }
    .project-timeline-sec .time-sec h2{
      text-align: center !important;
      margin: 0 0 20px;
    }
  }
.custRecurringOverlay{
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/business/Project.vue